<template>
    <div class="config-manager apply-bootstrap">
        <div v-show="systemMessage" id="systemMessage">
            <control ref="systemMessage" name="SYSTEM_MASSAGE" :prop-config="toastControl" :value="systemMessage"></control>
        </div>
        <layout-container v-if="!loading" c-id="layoutSignin"></layout-container>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { library } from "@common/library/library";
import { signinStore } from "@signin/signinStore";

const signinCmp = {
    data: function () {
        return {
            loading: true,
            lastSessionCheck: false,
            lastAction: false,
            tabVisitTime: false,
            systemMessage: false,
            timeouts: {},
            toastControl: {
                name: 'SYSTEM_MASSAGE',
                type: 'toast',
                width: '800px',
                cssClass: 'system-message-warning',
                timeOut: '0',
                position: { X: "Center", Y: "Top" },
                showCloseButton: true,
                target: '#systemMessage'
            }
        };
    },
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue')),
        control: defineAsyncComponent(() => import('@common/control/control.vue'))
    },
    computed: {
        signinStore() {
            return signinStore.state;
        }
    },
    methods: {
        onClick: function () {
            this.lastAction = new Date().getTime() / 1000; // NOSONAR
        },
        setupStation: function () {
            let sisID = typeof SIGNIN_STATION_ID !== 'undefined' ? SIGNIN_STATION_ID : 0;
            sDs.post("er_setupSigninStation", '', '', sisID, -(new Date().getTimezoneOffset() / 60)).then(async (response) => {
                if (response.status === 'success') {
                    if (response.data && response.data.sId) {
                        signinStore.set('stationId', response.data.sId);
                        await library.promiseAllSettled([
                            signinStore.getStationSettings(),
                            configStore.getAccountSettings()
                        ]);
                        this.sessionValidation(300); // NOSONAR
                    }
                }
                this.loading = false;
                library.hideLoadingIndicator('app');
            });
        },
        sessionValidation: function (loopSeconds) {
            if (loopSeconds) {
                let currCheck = new Date().getTime() / 1000; // NOSONAR
                if (typeof this.timeouts["sessionTimeout"] !== "undefined") {
                    clearTimeout(this.timeouts["sessionTimeout"]);
                }
                if (!this.lastSessionCheck) {
                    this.lastSessionCheck = currCheck - loopSeconds;
                }
                if ((currCheck - this.lastSessionCheck) >= (loopSeconds - 1)) { // NOSONAR
                    this.lastSessionCheck = currCheck;
                    sDs.post("er_sisSessionUpdate").then((response) => {
                        if (response.data && response.data.reset) {
                            SIGNIN_STATION_ID = '';
                            location.href = PROJECTS_URL + "/signin?reset";
                        }
                        if (response.status === 'failure' && response.error.length) {
                            let message = response.error.join(" ");
                            if (this && this.controls && this.controls['ERROR']) {
                                this.controls['ERROR'].value = message;
                            } else {
                                library.showToast(message);
                            }
                            return;
                        }
                        let systemMessage = response.data && response.data.systemMessage ? response.data.systemMessage : false;
                        if (systemMessage) {
                            systemMessage = '<div class="incompat-browser-icon-1">!</div><div>' + systemMessage + '</div>';
                        }
                        this.systemMessage = systemMessage;
                        if (!this.signinStore.volunteer && (currCheck - this.lastAction) >= 600) { // NOSONAR
                            this.reloadStation();
                        }
                    });
                }
                this.timeouts["sessionTimeout"] = setTimeout(() => {
                    this.sessionValidation(loopSeconds);
                }, loopSeconds * 1000); // NOSONAR
            }
        },
        reloadStation: function () {
            if (this.signinStore.volunteer) return;
            let sisID = library.getCookie("sisID");
            let emailCRC = typeof EMAIL_CRC !== 'undefined' ? EMAIL_CRC : null;
            let url = PROJECTS_URL + "/signin";
            if (typeof sisID === 'undefined' && typeof SIGNIN_STATION_ID !== 'undefined') {
                sisID = SIGNIN_STATION_ID;
            }
            if (sisID) {
                if (emailCRC) {
                    url += "?emailcrc=" + emailCRC;
                } else {
                    url += "?sisID=" + sisID;
                }
            }
            location.href = url;
        },
    },
    mounted: /* istanbul ignore next */ function () {
        library.showLoadingIndicator('app');
        if (!this.signinStore.stationId) {
            let sisID = false;
            if (FROM_LOCALHOST) {
                sisID = library.urlParser.getParams('sisID');
                if (sisID && typeof SIGNIN_STATION_ID !== 'undefined') {
                    SIGNIN_STATION_ID = sisID;
                }
            }
            sisID = library.getCookie("sisID");
            if (typeof sisID === 'undefined' && typeof SIGNIN_STATION_ID !== 'undefined') {
                sisID = SIGNIN_STATION_ID;
            }
            if (sisID) {
                this.setupStation();
            } else {
                this.loading = false;
                library.hideLoadingIndicator('app');
            }
        }
        this.onClick();
        document.addEventListener("click", this.onClick);
        document.addEventListener("keydown", this.onClick);
        this.tabVisitTime = Date.now() / 1000 / 60; // NOSONAR
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === 'visible') {
                let currentTime = Date.now() / 1000 / 60; // NOSONAR
                if ((currentTime - this.tabVisitTime) > 10) { // NOSONAR
                    this.reloadStation();
                }
            } else {
                this.tabVisitTime = Date.now() / 1000 / 60; // NOSONAR
            }
        });
    },
    unmounted() {
        document.removeEventListener("click", this.onClick);
        document.removeEventListener("keydown", this.onClick);
        for (let i in this.timeouts) {
            if (i === 'length') continue;
            clearTimeout(this.timeouts[i]);
        }
    }
};

export default signinCmp;
</script>

<style lang="css">
.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
    padding: 0;
}

#systemMessage {
    width: 100%;
    margin-bottom: 10px;
}

.e-toast .system-message-warning {
    font-size: 16px;
    background: white !important;
    color: #555555 !important;
}

.e-toast-container .e-toast.system-message-warning .e-toast-message .e-toast-content,
.e-toast-container .e-toast.system-message-warning .e-toast-close-icon.e-icons
{
    color: #555555;
}

.system-message-warning a {
    color: #242FC9;
}

#systemMessage .e-control.e-toast.e-lib.e-toast-container.e-toast-top-center {
    position: relative !important;
}

.incompat-browser-icon-1 {
    background: #E06D3C;
    font-size: 45px;
    font-weight: bold;
    line-height: 36px;
    margin: 14px;
    padding: 10px;
    color: #ffffff;
    text-align: center;
    border: 0 none;
    width: 50px;
    height: 50px;
    display: block;
    float: left;
}
</style>
